export default __webpack_public_path__ + "static/Industriali-0cb465d032430151a0e83c951fb8283d.jpg";